<template>
  <v-img
    :src="image"
    :height="height"
  >
    <v-row
      align="center"
      justify="center"
      class="teaser-image-shader"
      style="margin: 0px;"
    >
      <v-col
        class="text-center"
        cols="12"
      >
        <h1 :class="titleStyle || 'white--text display-3'">
          {{title}}
        </h1>
      </v-col>
    </v-row>
  </v-img>
</template>

<script>
  export default {
    name: 'ImageWithText',
    props: {
      title: String,
      image: String,
      height: Number,
      titleStyle: String,
    },
    data: () => ({
    }),
  }
</script>
